var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71408 5.7143V7.51239C4.60447 7.54582 3.94264 7.66957 3.48456 8.12765C2.85693 8.75527 2.85693 9.76543 2.85693 11.7857V13.0591C2.85693 14.8714 2.85693 15.7775 3.49583 16.5645C4.13474 17.3516 4.87723 17.5075 6.36222 17.8194C7.43263 18.0442 8.67889 18.2143 9.99979 18.2143C11.3207 18.2143 12.5669 18.0442 13.6374 17.8194C15.1223 17.5075 15.8648 17.3516 16.5037 16.5645C17.1426 15.7775 17.1426 14.8714 17.1426 13.0591V11.7857C17.1426 9.76543 17.1426 8.75527 16.515 8.12765C16.0569 7.66957 15.3951 7.54582 14.2855 7.51239V5.7143C14.2855 3.34737 12.3667 1.42859 9.99979 1.42859C7.63286 1.42859 5.71408 3.34737 5.71408 5.7143ZM9.99979 3.57145C8.81632 3.57145 7.85693 4.53084 7.85693 5.7143V7.50002H12.1426V5.7143C12.1426 4.53084 11.1833 3.57145 9.99979 3.57145ZM11.0364 12.7688C10.8609 12.9537 10.7141 13.1802 10.7141 13.4352V14.2857C10.7141 14.6802 10.3943 15 9.99979 15C9.6053 15 9.2855 14.6802 9.2855 14.2857V13.4352C9.2855 13.1802 9.13871 12.9537 8.96323 12.7688C8.72027 12.5127 8.57122 12.1666 8.57122 11.7857C8.57122 10.9968 9.21081 10.3572 9.99979 10.3572C10.7888 10.3572 11.4284 10.9968 11.4284 11.7857C11.4284 12.1666 11.2793 12.5127 11.0364 12.7688Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock28);
export default __webpack_public_path__ + "static/media/lock_28.b9c5fc7f.svg";
export { ForwardRef as ReactComponent };